import { ResourceEntryType } from '@ms/yammer-telemetry/dist/performance';

import { getTelemetryClientConfig, getTelemetryHostingConfig } from '../telemetryStore';

import { getOperationNameFromServerTiming, getResourceEntryType } from './resourceParser';

const graphqlOperationsToExclude = ['ReportTelemetryEventsClients'];

const isValidGraphqlOperation = (serverTiming: readonly PerformanceServerTiming[]) => {
  const operationName = getOperationNameFromServerTiming(serverTiming);

  return !!operationName && !graphqlOperationsToExclude.includes(operationName);
};

const isReportableGraphqlResourceEntry = (resourceEntry: PerformanceResourceTiming) =>
  !!resourceEntry.serverTiming && isValidGraphqlOperation(resourceEntry.serverTiming);

const isReportableJavaScriptResourceEntry = (resourceEntry: PerformanceResourceTiming) => {
  const skipResourceTimingReportForExternalJavascript =
    getTelemetryClientConfig().skipResourceTimingReportForExternalJavascript;
  if (skipResourceTimingReportForExternalJavascript) {
    const scriptBaseUrl = getTelemetryHostingConfig().scriptBaseUrl;
    if (scriptBaseUrl) {
      return resourceEntry.name.indexOf(scriptBaseUrl) > -1;
    }
  }

  return true;
};

const reportableResourceEntryTypes: ResourceEntryType[] = [
  ResourceEntryType.Flighting,
  ResourceEntryType.GraphQL,
  ResourceEntryType.JavaScript,
];

type IsReportableResourceEntry = (resourceEntry: PerformanceResourceTiming) => boolean;
export const isReportableResourceEntry: IsReportableResourceEntry = (resourceEntry) => {
  const resourceType = getResourceEntryType(resourceEntry);

  switch (resourceType) {
    case ResourceEntryType.GraphQL:
      return isReportableGraphqlResourceEntry(resourceEntry as PerformanceResourceTiming);
    case ResourceEntryType.JavaScript:
      return isReportableJavaScriptResourceEntry(resourceEntry);
    default:
      return reportableResourceEntryTypes.includes(resourceType);
  }
};
